module.exports = __webpack_public_path__ + "static/img/spfr.3628101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/spfr.jpg
// module id = mcrp
// module chunks = 0